import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class NavigationService {
    constructor(public router: Router,
    ) { }
    //todo: navigate
    navigation(path: string) {
        this.router.navigate([`/${path}`]);
    }
    //todo: navigate

    navigationWithParams(commands: any[], extras?: NavigationExtras) {
        this.router.navigate(commands, extras);
    }
}
